import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=638b7eaa&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=ts&"
export * from "./Tag.vue?vue&type=script&lang=ts&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=638b7eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b7eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('638b7eaa', component.options)
    } else {
      api.reload('638b7eaa', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=638b7eaa&scoped=true&", function () {
      api.rerender('638b7eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/Tag.vue"
export default component.exports